import { getSubMenuUrls } from '~/assets/js/utils/submenu';

const submenu = {
  namespaced: true,
  state: {
    root: {
      name: 'Enem',
      path: '',
    },
    urls: getSubMenuUrls(),
  },
  mutations: {
    setSubMenu(state, payload) {
      state.root = payload.root ? payload.root : state.root;
      state.urls = payload.urls;
    } 
  },
  getters: {
    getSubMenu: state => {
      return state;
    },
  },
  actions: {
    setSubMenu({ commit }, data) {
      commit('setSubMenu', data);
    }
 },
};

export default submenu;